import { cn } from "@babybjorn/ui";
import type { FC, HTMLAttributes, PropsWithChildren } from "react";

import * as s from "./ThreeUp.module.scss";

type ThreeUpProps = PropsWithChildren<
	HTMLAttributes<HTMLDivElement> & {
		headline?: string;
		label?: string;
		notThree?: boolean;
	}
>;
/**
 * This is used for both ThreeUp and TwoUp
 */
const ThreeUp: FC<ThreeUpProps> = ({
	headline,
	children,
	label,
	notThree = false,
}) => {
	return (
		<div className={s.container}>
			{label && <label>{label}</label>}
			{headline && <h2>{headline}</h2>}
			<section
				className={cn(s.wrapper, {
					[s.notThree]: notThree,
				})}
			>
				{children}
			</section>
		</div>
	);
};

export default ThreeUp;
